import { render, staticRenderFns } from "./application_details.vue?vue&type=template&id=1438e71c&scoped=true&"
import script from "./application_details.vue?vue&type=script&lang=js&"
export * from "./application_details.vue?vue&type=script&lang=js&"
import style0 from "./application_details.vue?vue&type=style&index=0&id=1438e71c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438e71c",
  null
  
)

export default component.exports